import QueryKeyFactory from "../../../api/hooks/utils/queryKeyFactory";

export const bomKeys = new QueryKeyFactory('bom')

